<template>
  <div id="app" class="app">
    <div class="account-main-wrap">
      <router-view></router-view>
    </div>
    <footer-container></footer-container>
  </div>
</template>

<script>

import FooterContainer from 'top20common/containers/TheFooterContainer';

export default {
  created() {
    this.$store.dispatch('fetchFeatureSwitchesAction');
    this.$mam.setUTMTags();
  },
  beforeMount() {
    const prefix = this.$language.isEnglish() ? "en/" : "";
    const link = `https://www.cgpgroup.com/${prefix}site/job_Search`;
    document.querySelector('header > a.logo').setAttribute('href', link);
  },
  components: {FooterContainer}
};
</script>

<style lang="scss">
@import '~CommonStyles/main.scss';
@import '~CommonStyles/extended/dropdown.scss';
@import '~CommonStyles/extended/button.scss';
@import '~CommonStyles/extended/tooltip.scss';
@import '~CommonStyles/extended/b-radio.scss';
@import '~CommonStyles/hopscotch.scss';
@import '~CommonStyles/typography.scss';

@media screen and (min-width: $tablet) {
  .register-page header a.logo {
    float: right;
    margin-right: 40px;
  }
}

.mobile-footer {
  padding-top: 50px;
  bottom: 0;
}
</style>
